import { render } from "./TextEditorLink.vue?vue&type=template&id=c07a230a&scoped=true"
import script from "./TextEditorLink.vue?vue&type=script&lang=js"
export * from "./TextEditorLink.vue?vue&type=script&lang=js"

import "./TextEditorLink.vue?vue&type=style&index=0&id=c07a230a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07a230a"]])

export default __exports__